module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/pdp_paperLinen-c59585cc7c4c44654f8aa2fe006c4ca7.jpg";